import { useEffect, useState } from 'react';
import './ContactPage.css';
import discordIconSVG from '../images/home/discord-icon.svg';
import ReasonNav from '../components/reason/ReasonNav';
import ReasonFooter from '../components/reason/ReasonFooter';
import { SITE_DISCORD, SITE_EMAIL } from '../data/siteContact';

function ContactPage() {
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const root = document.getElementById('root');
    const prevRootBg = root?.style.backgroundColor;
    if (root) root.style.backgroundColor = '#111013';
    return () => {
      document.body.style.overflow = '';
      if (root) root.style.backgroundColor = prevRootBg || '';
    };
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
  }, [menuOpen]);

  return (
    <div className={`reason-page contact-page${menuOpen ? ' menu-open' : ''}`}>
      <ReasonNav menuOpen={menuOpen} setMenuOpen={setMenuOpen} />

      <div className="container play-body">
        <div className="recommended">
          <h2>Contact Us</h2>
        </div>
      </div>

      <div className="container" style={{ position: 'relative', zIndex: 1 }}>
        <div className="row mt-5">
          <div className="col-md-5 main-container">
            <p className="secondary-title" style={{ marginBottom: 10 }}>
              Contact By Email
            </p>
            <p className="secondary-text" style={{ marginBottom: 10 }}>
              We provide support through email, allow us up to 72 hours to reply.
            </p>
            <a href={`mailto:${SITE_EMAIL}`}>{SITE_EMAIL}</a>
          </div>
          <div className="col-md-1" />
          <div className="col-md-5 main-container">
            <p className="secondary-title" style={{ marginBottom: 10 }}>
              Discord Help
            </p>
            <p className="secondary-text" style={{ marginBottom: 10 }}>
              Join our discord and message one of our team directly for the fastest support
            </p>
            <div style={{ display: 'flex' }}>
              <a
                href={SITE_DISCORD}
                className="button third"
                style={{ paddingLeft: 50, paddingRight: 60 }}
                target="_blank"
                rel="noreferrer"
              >
                <img src={discordIconSVG} alt="play now" />
                Join Discord
              </a>
            </div>
          </div>
        </div>
      </div>

      <ReasonFooter />
    </div>
  );
}

export default ContactPage;
